<template>
  <div class="company-wrap">
    <el-button class="view-btn" type="text" :disabled="!companyId && !companyName" @click="handleClick" icon="el-icon-office-building">工商信息</el-button>
    <el-dialog title="工商信息" class="crm-detail company-dialog" :visible.sync="visible" width="60%" append-to-body>
      <p style="font-size: 18px; font-weight: 500; margin-top: 0; margin-bottom: 20px;">{{companyInfo.companyName}}</p>
      <el-card shadow="never" class="el-card-simple">
        <div slot="header">
          <span>基本信息</span>
        </div>
        <el-form ref="form" label-width="115px">
          <el-row :gutter="20" align="left">
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="公司类型:">
                <span class="value">{{companyInfo.basicInfo.companyOrgType}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="行业:">
                <span class="value">{{companyInfo.basicInfo.industry}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="法定代表人:">
                <span class="value">{{companyInfo.basicInfo.legalPersonName}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="注册资本:">
                <span class="value">{{companyInfo.basicInfo.regCapital}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="注册地址:">
                <span class="value">{{companyInfo.basicInfo.regLocation}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :xs="24" :md="12" :lg="12">-->
<!--              <el-form-item label="办公地址:">-->
<!--                <p class="value">{{companyInfo.basicInfo.Address}}</p>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="电话:">
                <span class="value">{{companyInfo.basicInfo.phoneNumber}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :xs="24" :md="12" :lg="12">-->
<!--              <el-form-item label="传真:">-->
<!--                <span class="value"></span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="邮箱:">
                <span class="value">{{companyInfo.basicInfo.email}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="网址:">
                <span class="value">{{companyInfo.basicInfo.websiteList}}</span>
              </el-form-item>
            </el-col>
<!--            <el-col :xs="24" :md="12" :lg="12">-->
<!--              <el-form-item label="微博:">-->
<!--                <span class="value"></span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :xs="24" :md="12" :lg="12">-->
<!--              <el-form-item label="邮政编码:">-->
<!--                <span class="value"></span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="注册号:">
                <span class="value">{{companyInfo.basicInfo.regNumber}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="组织机构代码号:">
                <span class="value">{{companyInfo.basicInfo.orgNumber}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="社会信用代码:">
                <span class="value">{{companyInfo.basicInfo.creditCode}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="登记机关:">
                <span class="value">{{companyInfo.basicInfo.regInstitute}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="登记状态:">
                <span class="value">{{companyInfo.basicInfo.regStatus}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="营业开始时间:">
                <span class="value">{{parseTime(companyInfo.basicInfo.fromTime, '{y}-{m}-{d}')}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="营业结束时间:">
                <span class="value">{{parseTime(companyInfo.basicInfo.toTime, '{y}-{m}-{d}')}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="成立日期:">
                <span class="value">{{parseTime(companyInfo.basicInfo.estiblishTime, '{y}-{m}-{d}')}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" :lg="12">
              <el-form-item label="核准日期:">
                <span class="value">{{parseTime(companyInfo.basicInfo.approvedTime, '{y}-{m}-{d}')}}</span>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="24" :lg="24">
              <el-form-item label="经营范围:">
                <p class="value">{{companyInfo.basicInfo.businessScope}}</p>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
<!--      <el-card shadow="never" class="el-card-simple">-->
<!--        <div slot="header">-->
<!--          <span>股东信息</span>-->
<!--        </div>-->
<!--        <el-row :gutter="20" class="title-row">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">股东姓名</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">股东类型</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="20" v-for="(item, index) in companyInfo.shareholderInfo" :key="index" class="value-row" type="flex" align="middle">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{item.name}}</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{formatHolderType(item.type)}}</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-card>-->
<!--      <el-card shadow="never" class="el-card-simple">-->
<!--        <div slot="header">-->
<!--          <span>主要人员</span>-->
<!--        </div>-->
<!--        <el-row :gutter="20" class="title-row">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">姓名</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">职位</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="20" v-for="(item, index) in companyInfo.memberInfo" :key="index" class="value-row" type="flex" align="middle">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{item.name}}</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{item.typeJoin && item.typeJoin.length > 0 ? item.typeJoin.join("、") : ""}}</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-card>-->
<!--      <el-card shadow="never" class="el-card-simple">-->
<!--        <div slot="header">-->
<!--          <span>分支机构</span>-->
<!--        </div>-->
<!--        <el-row :gutter="20" class="title-row">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">序号</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">机构名称</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="20" v-for="(item, index) in companyInfo.branchInfo" :key="index" class="value-row" type="flex" align="middle">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{index + 1}}</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value" style="word-break:keep-all;">{{item.name}}</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-card>-->
<!--      <el-card shadow="never" class="el-card-simple">-->
<!--        <div slot="header">-->
<!--          <span>变更信息</span>-->
<!--        </div>-->
<!--        <el-row :gutter="20" class="title-row">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">变更日期</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="label">变更事项</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="12" :md="12" :lg="12" align="center">-->
<!--            <span class="label">变更后内容</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="20" v-for="(item, index) in companyInfo.changeInfo" :key="index" class="value-row" type="flex" align="middle">-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{item.ChangeDate}}</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="8" :md="8" :lg="8" align="center">-->
<!--            <span class="value">{{item.ProjectName}}</span>-->
<!--          </el-col>-->
<!--          <el-col :xs="12" :md="12" :lg="12" align="center">-->
<!--            <span class="value" v-for="(after, index2) in item.AfterList" :key="index2">{{after}};</span>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-card>-->
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyDetail } from "@/api/crm/company";

export default {
  name: "CompanyInfoButton",
  props: {
    value: {},
    companyName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      companyId: this.value,
      companyInfo: {
        basicInfo: {},
        branchInfo: [],
        changeInfo: [],
        memberInfo: [],
        shareholderInfo: []
      },
      visible: false
    };
  },
  watch: {
    value (val) {
      this.companyId = this.value
    }
  },
  methods: {
    getInfo() {
      this.companyInfo = {
        basicInfo: {},
        branchInfo: [],
        changeInfo: [],
        memberInfo: [],
        shareholderInfo: []
      }
      if (this.companyId || this.companyName) {
        let param = {}
        if (this.companyId) {
          param.creditCode = this.companyId
        } else {
          param.companyName = this.companyName
        }
        getCompanyDetail(param).then(response => {
          let companyInfo = response.data || {}
          companyInfo.basicInfo = this.safeToJson(companyInfo.basicInfo)
          companyInfo.branchInfo = this.safeToJson(companyInfo.branchInfo)
          // companyInfo.changeInfo = this.safeToJson(companyInfo.changeInfo)
          companyInfo.memberInfo = this.safeToJson(companyInfo.memberInfo)
          companyInfo.shareholderInfo = this.safeToJson(companyInfo.shareholderInfo)
          this.companyInfo = companyInfo
          console.log(companyInfo)
        })
      }
    },
    safeToJson(str) {
      if (str && str.length > 0 && (str.charAt(0) === '{' || str.charAt(0) === '[')) {
        return JSON.parse(str);
      }
      return {};
    },
    handleClick () {
      this.visible = true
      this.getInfo()
    },
    formatHolderType (type) {
      if (type == 1) {
        return "公司";
      } else if (type == 2) {
        return "自然人股东";
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang='scss'>
.view-btn{
  padding: 0;
}
.company-wrap {
  display: inline;
  padding: 0 10px;
}
.company-dialog{
  p{
    margin-top: 8px;
    margin-bottom: 0px;
  }
  .el-form-item{
    margin-bottom: 0;
  }
  .title-row{
    margin-bottom: 10px;
  }
  .value-row{
    margin-bottom: 10px;
  }
}
</style>
